import { ConcessionStore } from '../restaurant/restaurant.types';

// #region menu enum
export enum MenuSectionBehaviour {
  ExpandSingle = 0,
  ExpandMultiple = 1,
}

export enum CellLayoutType {
  Small = 0,
  Medium = 1,
  Large = 2,
}

export enum AvailabilityMode {
  DisplayAlways = 0,
  DisplayBasedOnTimes = 1,
  DisplayAlwaysStartCollapsed = 2,
  DisplayAlwaysStartCollapsedBasedOnTimes = 3,
}

export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}
// #endregion

// #region menu types
export interface Menu {
  CatalogItems: any;
  ConcessionStores: ConcessionStore[];
  DisplaySectionLinks: boolean;
  MenuId: number;
  MenuSectionBehaviour: MenuSectionBehaviour;
  MenuSections: any[]; // replace with MenuSection[] when selectors are removed
  MenuVersionNumber: number;
  VersionGuid: string;
  VirtualRestaurantId: number;
}

export interface MenuSection {
  CellAspectRatio: number;
  CellLayoutType: number;
  ConcessionStoreId?: number | null;
  Description?: string | null;
  DisplayOrder: number;
  ImageName?: string | null;
  ImageUrl?: string | null;
  IsAvailable: boolean;
  IsDeleted: boolean;
  IsHiddenFromUsers: boolean;
  MenuItems: MenuItem[];
  MenuSectionAvailability: MenuSectionAvailability;
  MenuSectionId: number;
  MenuSectionMetadata: any[];
  Name: string;
  PublicId: string;
}

interface MenuItemCommon {
  CellLayoutType: CellLayoutType | Fd.MenuSectionItemBase['CellLayoutType'];
  DisplayOrder: number;
  ImageUrl?: string;
  Name?: string;
  Price?: number;
}

export interface MenuItem extends MenuItemCommon {
  ActualPrice: number;
  Alcohol: boolean;
  CatalogItemId: number;
  ConcessionStoreId?: number;
  DailySpecialHours: any[];
  Description?: string;
  DisableVouchers: boolean;
  ExcludeFromVoucherDiscounting: boolean;
  ExternalImageUrl: string;
  ImageName: string;
  IsAvailable: boolean;
  IsDeleted: boolean;
  MenuId: number;
  MenuItemId: number;
  MenuItemMetadata: any[];
  MenuItemOptionSets: MenuItemOptionSet[];
  MenuSectionId: number;
  PriceCanIncrease: boolean;
  PublicId: string;
  SpicinessRating: number;
  Tags: any[];
  TaxRateId: number;
  TaxRateName: string;
  TaxValue: number;
}

export interface MenuItemOptionSet extends MenuItemCommon {
  IsMasterOptionSet: boolean;
  MaxSelectCount: number;
  MenuItemOptionSetId: number;
  MenuItemOptionSetItems: MenuItemOptionSetItem[];
  MinSelectCount: number;
}

export interface MenuItemOptionSetItem extends MenuItemCommon {
  IsAvailable: boolean;
  MenuItemOptionSetItemId: number;
  NextMenuItemOptionSetId?: number;
  TaxValue?: number;
}

interface MenuSectionAvailability {
  AvailabilityMode: AvailabilityMode;
  AvailableTimes?: BusinessHoursPeriod[] | null;
  MenuSectionId: number;
}

export interface BusinessHoursPeriod {
  BusinessHoursPeriodId: number;
  DayOfWeek: DayOfWeek;
  StartTime: string;
  Period: string;
  StartTimeEarly: string | null;
  PeriodEarly: string | null;
}
// #endregion

// #region cross-sell types
export interface CrossSellMenuItems {
  MenuItemIds: number[];
}

export interface GetCrossSellMenuItemIdsQueryParams {
  limit: number;
  menuId: number;
  menuItemId: number[];
  totalValue: number;
}
// #endregion

// #region nutritional information types
export interface NutritionInfo {
  MenuItemOptionSetItems?: NutritionMenuItem[];
  MenuItems?: NutritionMenuItem[];
  Version: string;
}

export interface NutritionMenuItem {
  EnergyContent?: NutritionEnergyContent[];
  Labels: NutritionMenuItemLabel[];
  PublicId: string;
}

export interface NutritionEnergyContent {
  Max: number;
  Min: number;
  Unit: string;
}

export interface NutritionMenuItemLabel {
  IconUrl: string;
  Name: string;
  Values?: string[];
}
// #endregion
